<table *ngIf="kfRegistrationDetail" class="kf-registration-table" mat-table [dataSource]="kfRegistrationDetail.categories">
  <ng-container matColumnDef="entry">
    <th mat-header-cell *matHeaderCellDef>Entry</th>
    <td mat-cell *matCellDef="let category; let i = index" >
      {{categories[i].description}}
      <span>{{category.kind}}</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="mr">
    <th mat-header-cell *matHeaderCellDef>MR</th>
    <td mat-cell *matCellDef="let item"
        [matTooltip]="item.mrDifferentValueAllowed ? 'This value exceeded the marginal value established' : ''">
      <span [className]="item.mrDifferentValueAllowed ? 'value-exceeded' : ''">{{item.mr | number: '1.2-2'}} %</span>
      <span class="value-exceeded" *ngIf="item.mrDifferentValueAllowed">*</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="omr">
    <th mat-header-cell *matHeaderCellDef>OMR</th>
    <td mat-cell *matCellDef="let item"
        [matTooltip]="item.omrDifferentValueAllowed ? 'This value exceeded the marginal value established' : ''">
      <span [className]="item.omrDifferentValueAllowed ? 'value-exceeded' : ''">{{item.omr | number: '1.2-2'}} %</span>
      <span class="value-exceeded" *ngIf="item.omrDifferentValueAllowed">*</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="ru">
    <th mat-header-cell *matHeaderCellDef>RU</th>
    <td mat-cell *matCellDef="let item"
        [matTooltip]="item.ruDifferentValueAllowed ? 'This value exceeded the marginal value established' : ''">
      <span [className]="item.ruDifferentValueAllowed ? 'value-exceeded' : ''">{{item.ru | number: '1.2-2'}} %</span>
      <span class="value-exceeded" *ngIf="item.ruDifferentValueAllowed">*</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="er">
    <th mat-header-cell *matHeaderCellDef>ER</th>
    <td mat-cell *matCellDef="let item"
        [matTooltip]="item.erDifferentValueAllowed ? 'This value exceeded the marginal value established' : ''">
      <span [className]="item.erDifferentValueAllowed ? 'value-exceeded' : ''">{{item.er | number: '1.2-2'}} %</span>
      <span class="value-exceeded" *ngIf="item.erDifferentValueAllowed">*</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="td">
    <th mat-header-cell *matHeaderCellDef>TD</th>
    <td mat-cell *matCellDef="let item"
        [matTooltip]="item.tdDifferentValueAllowed ? 'This value exceeded the marginal value established' : ''">
      <span [className]="item.tdDifferentValueAllowed ? 'value-exceeded' : ''">{{item.td | number: '1.2-2'}} %</span>
      <span class="value-exceeded" *ngIf="item.tdDifferentValueAllowed">*</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="ld">
    <th mat-header-cell *matHeaderCellDef>LD</th>
    <td mat-cell *matCellDef="let item"
        [matTooltip]="item.ldDifferentValueAllowed ? 'This value exceeded the marginal value established' : ''">
      <span [className]="item.ldDifferentValueAllowed ? 'value-exceeded' : ''">{{item.ld | number: '1.2-2'}} %</span>
      <span class="value-exceeded" *ngIf="item.ldDifferentValueAllowed">*</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="loss">
    <th mat-header-cell *matHeaderCellDef>Loss</th>
    <td mat-cell *matCellDef="let item"
        [matTooltip]="item.lossDifferentValueAllowed ? 'This value exceeded the marginal value established' : ''">
      <span [className]="item.lossDifferentValueAllowed ? 'value-exceeded' : ''">{{item.loss | number: '1.2-2'}} %</span>
      <span class="value-exceeded" *ngIf="item.lossDifferentValueAllowed">*</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="total">
    <th mat-header-cell *matHeaderCellDef>Total</th>
    <td mat-cell *matCellDef="let item">
      {{getTotalValue(item)  | number: '1.2-2'}} %
    </td>
  </ng-container>
  <ng-container matColumnDef="remark">
    <th mat-header-cell *matHeaderCellDef>Remark</th>
    <td mat-cell *matCellDef="let item"> {{item.remark}} </td>

    <td mat-footer-cell *matFooterCellDef> </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
